(function () {
    'use strict';

    angular.module("imApp").factory("seasonalityService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 850,
                    parameters: parms || {}
                });
            },
            listMonths: function (parms) {
                return $ihttp.post({
                    method: 851,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 852,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
